import React from "react";
import "./ExaminationInfoCard.css";
import { Badge, Col, Dropdown, DropdownButton, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleNotch,
  faCogs,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import ExaminationStatus from "../../../helpers/ExaminationStatus";

import SecurityLevel from "../../../helpers/SecurityLevel";

class ExaminationInfoCard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.securityLevelsLabels = new Map(
      SecurityLevel.getSecurityLevels().map((i) => [i.value, i.label]),
    );

    this.isActionDropdownDisabled = this.isActionDropdownDisabled.bind(this);
    this.formatDate = this.formatDate.bind(this);
  }

  isActionDropdownDisabled(status) {
    return (
      !ExaminationStatus.showClose(status) &&
      !ExaminationStatus.showOpen(status) &&
      !ExaminationStatus.showEdit(status) &&
      !ExaminationStatus.showRetry(status) &&
      !ExaminationStatus.showDelete(status) &&
      !ExaminationStatus.showSubmissionDownload(
        status,
        this.props.examination.instanceTemplate.type === 0,
      )
    );
  }

  formatDate(dateString) {
    const d = new Date(Date.parse(dateString));
    return d
      ? ("0" + d.getDate()).slice(-2) +
          "." +
          ("0" + (d.getMonth() + 1)).slice(-2) +
          "." +
          d.getFullYear() +
          " " +
          ("0" + d.getHours()).slice(-2) +
          ":" +
          ("0" + d.getMinutes()).slice(-2)
      : "-";
  }

  render() {
    const { t } = this.props;
    let instanceTemplateConfiguration = null;
    if (
      this.props.examination &&
      this.props.examination.instanceTemplate &&
      typeof this.props.examination.instanceTemplate["configuration"] !==
        "undefined" &&
      this.props.examination.instanceTemplate["configuration"]
    ) {
      try {
        instanceTemplateConfiguration = JSON.parse(
          atob(this.props.examination.instanceTemplate["configuration"]),
        );
      } catch (err) {
        console.error(err);
      }
    }

    const statusBar = ExaminationStatus.getStatusBar(
      this.props.examination ? this.props.examination.status : 0,
    );

    let status;
    switch (this.props.examination.status) {
      case 1:
      case 11:
      case 21:
      case 31:
      case 50:
      case 61:
        status = (
          <Badge className="btn-green">
            {t(
              ExaminationStatus.getTranslationByStatus(
                this.props.examination.status,
              ),
            )}
          </Badge>
        );
        break;
      case 0:
      case 10:
      case 20:
      case 30:
      case 32:
      case 40:
      case 51:
      case 60:
        status = (
          <Badge className="btn-black">
            <FontAwesomeIcon icon={faCircleNotch} spin className="mr-1" />
            {t(
              ExaminationStatus.getTranslationByStatus(
                this.props.examination.status,
              ),
            )}
          </Badge>
        );
        break;
      default:
        status = (
          <Badge className="btn-red">
            {t(
              ExaminationStatus.getTranslationByStatus(
                this.props.examination.status,
              ),
            )}
          </Badge>
        );
        break;
    }

    const body = this.props.tReady ? (
      <>
        <Row className="pageTitle">
          <Col>
            <h2>
              {t("SingleExamination.Title")}:{" "}
              {this.props.examination ? this.props.examination.name : ""}
            </h2>
          </Col>
          <Col>
            <div style={{ float: "right" }}>
              <DropdownButton
                disabled={this.isActionDropdownDisabled(
                  this.props.examination.status,
                )}
                onClick={(event) => event.stopPropagation()}
                title={<FontAwesomeIcon icon={faCogs} />}
              >
                {ExaminationStatus.showEdit(this.props.examination.status) && (
                  <>
                    <Dropdown.Item onClick={this.props.onEdit}>
                      {t("SingleExamination.ActionCell.EditOption")}
                    </Dropdown.Item>
                    <Dropdown.Divider />
                  </>
                )}
                {ExaminationStatus.showOpen(this.props.examination.status) && (
                  <Dropdown.Item onClick={this.props.onOpen}>
                    {t("SingleExamination.ActionCell.OpenOption")}
                  </Dropdown.Item>
                )}
                {ExaminationStatus.showClose(this.props.examination.status) && (
                  <Dropdown.Item onClick={this.props.onClose}>
                    {t("SingleExamination.ActionCell.CloseOption")}
                  </Dropdown.Item>
                )}
                {/**ExaminationStatus.showPause(
                  this.props.examination.status,
                  this.props.examination.instanceTemplate.type === 0,
                ) && (
                  <Dropdown.Item onClick={this.props.onPause}>
                    {t("SingleExamination.ActionCell.PauseOption")}
                  </Dropdown.Item>
                )**/}
                {/**ExaminationStatus.showResume(
                  this.props.examination.status,
                  this.props.examination.instanceTemplate.type === 0,
                ) && (
                  <Dropdown.Item onClick={this.props.onResume}>
                    {t("SingleExamination.ActionCell.ResumeOption")}
                  </Dropdown.Item>
                ) **/}
                {ExaminationStatus.showRetry(this.props.examination.status) && (
                  <Dropdown.Item onClick={this.props.onRetry}>
                    {t("SingleExamination.ActionCell.RetryOption")}
                  </Dropdown.Item>
                )}
                {ExaminationStatus.showSubmissionDownload(
                  this.props.examination.status,
                  this.props.examination.instanceTemplate.type === 0 ||
                    (instanceTemplateConfiguration &&
                      typeof instanceTemplateConfiguration.static[
                        "enable_smb_share"
                      ] !== "undefined" &&
                      instanceTemplateConfiguration.static.enable_smb_share),
                ) && (
                  <Dropdown.Item
                    onClick={() => this.props.onDownloadSubmissions()}
                  >
                    {t("SingleExamination.ActionCell.DownloadSubmissions")}
                  </Dropdown.Item>
                )}

                {ExaminationStatus.showPINCodeExport(
                  this.props.examination.status,
                ) && (
                  <>
                    {!ExaminationStatus.showEdit(
                      this.props.examination.status,
                    ) && <Dropdown.Divider />}
                    <Dropdown.Item
                      onClick={() => this.props.onExport(0, "pdf", 0)}
                    >
                      {t(
                        "SingleExamination.ActionCell.ExportPINCodePDFOption1",
                      )}
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => this.props.onExport(0, "pdf", 1)}
                    >
                      {t(
                        "SingleExamination.ActionCell.ExportPINCodePDFOption2",
                      )}
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => this.props.onExport(0, "csv")}
                    >
                      {t("SingleExamination.ActionCell.ExportPINCodeCSVOption")}
                    </Dropdown.Item>
                  </>
                )}
                {ExaminationStatus.showAttendanceListExport(
                  this.props.examination.status,
                ) && (
                  <>
                    {ExaminationStatus.showSubmissionDownload(
                      this.props.examination.status,
                      this.props.examination.instanceTemplate.type === 0,
                    ) && <Dropdown.Divider />}
                    <Dropdown.Item
                      onClick={() => this.props.onExport(1, "pdf", 1)}
                    >
                      {t(
                        "SingleExamination.ActionCell.ExportAttendanceListPDFOption",
                      )}
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => this.props.onExport(1, "csv")}
                    >
                      {t(
                        "SingleExamination.ActionCell.ExportAttendanceListCSVOption",
                      )}
                    </Dropdown.Item>
                  </>
                )}
                {ExaminationStatus.showDelete(
                  this.props.examination.status,
                ) && (
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={this.props.onDelete}>
                      {t("SingleExamination.ActionCell.DeleteOption")}
                    </Dropdown.Item>
                  </>
                )}
              </DropdownButton>
            </div>
          </Col>
        </Row>
        <Row className="mb-1">
          <Col>
            <div>
              <b className="mr-1">
                {t("SingleExamination.BasicInformation.Status")}:
              </b>
              {status}
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.Owner")}:</b>{" "}
              {this.props.examination.user}
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.Class")}:</b>{" "}
              {this.props.examination.className}
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.Module")}:</b>{" "}
              {this.props.examination.moduleName}
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.InstanceTemplate")}:</b>{" "}
              {this.props.examination.instanceTemplate.name}
              <FontAwesomeIcon
                className="item-link pl-1"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.onAdditionalInformation(
                    this.props.examination.instanceTemplate.description,
                    t("SingleExamination.BasicInformation.InstanceTemplate"),
                  );
                }}
                icon={faInfoCircle}
              />
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.NetworkProfile")}:</b>{" "}
              {this.props.examination.networkProfile.name}
              <FontAwesomeIcon
                className="item-link pl-1"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.onAdditionalInformation(
                    this.props.examination.networkProfile.description,
                    t("SingleExamination.BasicInformation.NetworkProfile"),
                  );
                }}
                icon={faInfoCircle}
              />
            </div>
          </Col>
          <Col style={{ borderLeft: "1px solid gray" }}>
            <div>
              <b>{t("SingleExamination.BasicInformation.InstancesCount")}:</b>{" "}
              {this.props.examination.instancesCount}
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.Start")}:</b>{" "}
              {this.formatDate(this.props.examination.start)}{" "}
              {this.props.examination.isAutoStart
                ? `(${t("SingleExamination.BasicInformation.AutoStart")})`
                : ""}
            </div>
            <div>
              <b>{t("SingleExamination.BasicInformation.End")}:</b>{" "}
              {this.formatDate(this.props.examination.end)}{" "}
              {this.props.examination.isAutoEnd
                ? `(${t("SingleExamination.BasicInformation.AutoEnd")})`
                : ""}
            </div>
            {this.props.examination.expiration && (
              <div>
                <b>{t("SingleExamination.BasicInformation.Expiration")}:</b>{" "}
                {this.formatDate(this.props.examination.expiration)}
              </div>
            )}
            <div>
              <b>{t("SingleExamination.BasicInformation.SecurityLevel")}:</b>{" "}
              {t(
                this.securityLevelsLabels.get(
                  this.props.examination.securityLevel,
                ),
              )}
            </div>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <div className="step-container">
              <ul className="step-progressbar">
                <li className={statusBar.creating}>
                  {t("ExaminationStatus.PREPARED")}
                </li>
                <li className={statusBar.ready}>
                  {t("ExaminationStatus.READY")}
                </li>
                <li className={statusBar.open}>
                  {t("ExaminationStatus.OPEN")}
                </li>
                <li className={statusBar.close}>
                  {t("ExaminationStatus.CLOSE")}
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </>
    ) : (
      <div>
        <Row className="pageTitle">
          <Col>
            <h2>
              {t("SingleExamination.Title")}:{" "}
              {this.props.examination ? this.props.examination.name : ""}
            </h2>
          </Col>
        </Row>
        <Row>
          <Col className="centered pt-5 pb-5">
            <FontAwesomeIcon icon={faCircleNotch} spin />
          </Col>
        </Row>
      </div>
    );

    return <div>{body}</div>;
  }
}

export default ExaminationInfoCard;
